import Vue from "vue";
import VueRouter from "vue-router";
import LoginView from "@/views/LoginView";
import Layout from "@/components/layout/Layout";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "userLogin",
      component: LoginView,
    },
    {
      path: '/ResetView',
      name: 'ResetView',
      props: (route) => ({ formData: route.query }),
      component: () => import(/* webpackChunkName: "user-otp" */ '../views/ResetView.vue')
    },
    {
      path: "/otp",
      name: "otp",
      component: function () {
        return import("../views/OTP.vue");
      },
    },
    {
      path: '/documentation',
      name: 'documentation',
      component: () => import(/* webpackChunkName: "documentation" */ '../views/Documentation.vue')
    },
    {
      path: "/",
      component: Layout,
      // meta: { requiresAuth: true },
      children: [
        {
          path: "/subs",
          name: "subs",
          component: function () {
            return import("../views/Home.vue");
          },
        },
        {
          path: "/inactive",
          name: "inactive",
          component: function () {
            return import("../views/InactiveAcc.vue");
          },
        },
        {
          path: "/all-customer",
          name: "customer",
          component: function () {
            return import("../views/Customer.vue");
          },
        },
        {
          path: "/tickets",
          name: "tickets",
          component: function () {
            return import("../views/Tickets.vue");
          },
        },
        {
          path: "/smart-invoicing",
          name: "smart-invoice",
          component: function () {
            return import("../views/SmartInvoicing.vue");
          },
        },
        {
          path: '/create-ticket',
          name: 'create-ticket',
          component: () => import(/* webpackChunkName: "create-ticket" */ '../views/tickets/view/AddEditTicketView')
        },
        {
          path: '/view-users',
          name: 'view-users',
          component: () => import(/* webpackChunkName: "create-ticket" */ '@/views/user/Users.vue')
        },
        {
          path: '/create-user',
          name: 'create-user',
          component: () => import(/* webpackChunkName: "create-user" */ '@/views/user/createUser.vue')
        },
        {
          path: '/edit-user',
          name: 'edit-user',
          component: () => import(/* webpackChunkName: "edit-ticket" */ '@/views/user/EditUser.vue')
        },
        {
          path: "/smart-invoicing-setup",
          name: "smart",
          component: function () {
            return import("../views/Smart-invoicing-setup.vue");
          },
        },
        {
          path: '/smart-invoice-product-list',
          name: 'smart-invoice-product-list',
          component: () => import(/* webpackChunkName: "smart-invoice-product-list" */ '../views/SmartInvoice/SIProductSelect')
        },
        {
          path: '/view-smart-invoice-signup',
          name: 'view-smart-invoice-signup',
          component: () => import(/* webpackChunkName: "view-smart-invoice-signup" */ '../views/SmartInvoice/ViewSmartInvoiceSignup')
        },
        {
          path: '/chrilan-smart-invoice',
          name: 'chrilan-smart-invoice',
          component: () => import(/* webpackChunkName: "chrilan-smart-invoice" */ '../views/SmartInvoice/Lyt-SI-Signup')
        },
        {
          path: '/kazang-smart-invoice',
          name: 'kazang-smart-invoice',
          component: () => import(/* webpackChunkName: "lytsoft-smart-invoice" */ '../views/SmartInvoice/Kazang-Signup.vue')
        },
        {
          path: '/kdiy-stores',
          name: 'kdiy-stores',
          component: () => import(/* webpackChunkName: "kdiy-stores" */ '../views/stores/StoreDetails.vue')
        },
        {
          path: '/create-store',
          name: 'create-store',
          component: () => import(/* webpackChunkName: "create-store" */ '../views/stores/CreateUser.vue')
        },

        {
          path: '/email-redirect-password-reset',
          name: 'email-redirect-password-reset',
          component: () => import(/* webpackChunkName: "ResetPasswordFromEmailRedirect" */ '../views/stores/ResetPasswordFromEmailRedirect/ResetPasswordFromEmailRedirect.vue')
        },
        {
          path: '/view-lytsoft-smart-invoice',
          name: 'view-lytsoft-smart-invoice',
          component: () => import(/* webpackChunkName: "view-lytsoft-smart-invoice" */ '../views/SmartInvoice/ViewLytSoftSmartInvoiceSignup')
        },
        {
          path: '/ticket/:ticketId',
          props: true,
          name: 'view-ticket',
          component: () => import(/* webpackChunkName: "view-ticket" */ '../views/tickets/view/TicketDetailsView')
        },
        {
          path: '/ticket/edit/:ticketId',
          name: 'edit-ticket',
          component: () => import(/* webpackChunkName: "edit-ticket" */ '../views/tickets/view/AddEditTicketView')
        },
        {
          path: 'ticket/:ticket/task',
          props: true,
          name: 'add-ticket-task',
          component: () => import(/*webpackChunkName: "add-task"*/'../views/tickets/tasks/TicketTaskView')
        },
        {
          path: 'ticket/:ticket/task/:task',
          props: true,
          name: 'edit-ticket-task',
          component: () => import(/*webpackChunkName: "edit-task"*/'../views/tickets/tasks/TicketTaskView')
        },
        {
          path: "/customer-invoices/:debtorId/:customer",
          name: "CustomerInvoices",
          component: () => import("@/views/CustomerDetails.vue")
        },
        {
          path: '/view-customer/:mainCustomerID',
          name: 'view-customer',
          component: () => import(/* webpackChunkName: "view-customer" */ '../views/customer/ViewCustomerInvoices.vue')
        },
        {
          path: '/view-customer-info/:customer',
          name: 'view-customer-info',
          component: () => import(/* webpackChunkName: "view-customer" */ '../views/customer/ViewCustomerDetails.vue')
        },
        {
          path: '/edit-customer-info/:customer',
          name: 'edit-customer-info',
          component: () => import(/* webpackChunkName: "view-customer" */ '../views/customer/EditCustomerDetails.vue')
        },
        {
          path: '/edit-store-info/:store',
          name: 'edit-store-info',
          component: () => import(/* webpackChunkName: "view-customer" */ '../views/stores/EditStore.vue')
        },
        {
          path: '/reset-password',
          name: 'reset-password',
          component: () => import(/* webpackChunkName: "view-customer" */ '../views/customer/ResetPassword/ResetPassword.vue')
        },
        {
          path: '/email-settings',
          name: 'email-settings',
          component: () => import(/* webpackChunkName: "view-customer" */ '../views/email/email.vue')
        },
      ],
    },
  ],
});

router.afterEach((to, from) => {
  if (window.usageTracker) {
    window.usageTracker.track({
      feature: 'page:' + (to.name || to.path),
      action: 'view',
    });
  }
});

router.beforeEach((to, from, next) => {
  const userData = localStorage.getItem("session_id");

  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (!userData) {
      return next({ name: "userLogin" });
    }
  }

  next();
});

export default router;
